import classNames from 'classnames';
import * as React from 'react';
import * as styles from './Dot.css';

export type TDotSize = 'S' | 'M' | 'L';

export interface IDotProps {
  active?: boolean;
  size: TDotSize;
}

export const DotComponent: React.FC<IDotProps> = ({ active, size }) => {
  return (
    <li
      className={classNames(styles['container'], styles[`container--size-${size.toLowerCase()}`], {
        [styles['container--active']]: active,
      })}
    />
  );
};

export const Dot = React.memo(DotComponent);
